module.exports = __webpack_public_path__ + "static/media/tiktokLogo.6a889089.png";